import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ee4e2d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container p-5" }
const _hoisted_2 = { class: "m-2 row position-relative" }
const _hoisted_3 = { class: "col text-center" }
const _hoisted_4 = { class: "display-6 text-inline" }
const _hoisted_5 = {
  class: "display-6 text-secondary",
  style: {"font-size":"2rem"}
}
const _hoisted_6 = { class: "row d-flex m-2 p-2 text-secondary text-center align-items-center justify-content-center" }
const _hoisted_7 = { class: "col-3 d-flex justify-content-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ps-2 bi bi-pin" }, null, -1))
const _hoisted_9 = { class: "col-3 d-flex justify-content-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ps-2 bi bi-cash-stack" }, null, -1))
const _hoisted_11 = { class: "col-3 d-flex justify-content-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ps-2 bi bi-calendar" }, null, -1))
const _hoisted_13 = { class: "col-3 d-flex justify-content-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ps-2 bi bi-laptop" }, null, -1))
const _hoisted_15 = { class: "m-2 text-secondary border rounded-3" }
const _hoisted_16 = {
  style: {"max-height":"40vh"},
  class: "m-2 overflow-y-auto"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "col" }

import { ref, computed, watch } from "vue";
import Modal from "@/components/Modal.vue";
import Gauge from "@/components/Gauge.vue";
import router from "../router";
import CreateApplication from "@/views/CreateApplication.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'JobDetailsModal',
  props: {
  job: Object,
},
  emits: ["open", "application-created"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const jobDetailsModal = ref<InstanceType<typeof Modal> | null>(null);
const showCreateApplicationModal = ref(false);

watch(
  () => props.job,
  (newJob) => {
    if (newJob && jobDetailsModal.value) {
      jobDetailsModal.value.show();
    }
  }
);

function toPascaleCase(str: string) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function formatDate(timestamp: number) {
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

function createApplication(job: any) {
  if (jobDetailsModal.value) {
    jobDetailsModal.value.hide();
  }
  showCreateApplicationModal.value = true;
  
  // Pre-populate application data from job if needed
  // This can be enhanced to pass job data to the CreateApplication component
}

function onApplicationCreated(applicationId: string) {
  showCreateApplicationModal.value = false;
  emits("application-created", applicationId);
  router.push(`/application/${applicationId}`);
}

function emitOpen(url: string) {
  emits("open", url);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      class: "modal-xl",
      ref_key: "jobDetailsModal",
      ref: jobDetailsModal,
      hideCloseButton: ""
    }, _createSlots({
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "btn btn-outline-primary mx-2 text-nowrap",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emitOpen(__props.job?.job_url)))
            }, " View on " + _toDisplayString(toPascaleCase(__props.job?.site)), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "btn btn-outline-primary mx-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (createApplication(__props.job)))
            }, " Create Application ")
          ])
        ])
      ]),
      _: 2
    }, [
      (__props.job)
        ? {
            name: "body",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.job.title), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(__props.job.company), 1)
                  ]),
                  _createVNode(Gauge, {
                    class: "gauge",
                    value: __props.job.match
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(__props.job.location), 1),
                      _hoisted_8
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(__props.job.min_amount) + " - " + _toDisplayString(__props.job.max_amount) + " " + _toDisplayString(__props.job.currency) + " ", 1),
                      _hoisted_10
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(formatDate(__props.job.date_posted)), 1),
                      _hoisted_12
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(__props.job.is_remote ? "Remote" : "Not Remote"), 1),
                      _hoisted_14
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(__props.job.description), 1)
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1536),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showCreateApplicationModal.value)
        ? (_openBlock(), _createBlock(CreateApplication, {
            key: 0,
            show: showCreateApplicationModal.value,
            "is-modal": true,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (showCreateApplicationModal.value = false)),
            onApplicationCreated: onApplicationCreated
          }, null, 8, ["show"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})